import React, { useEffect, useState } from 'react';
import BackToTop from '../../components/elements/BackToTop';
import Header from '../../components/Layout/Header';
import navImg1 from '../../assets/images/resources/ramana-steel-logo1.png';
import FooterTwo from '../../components/Layout/Footer/FooterStyleTwo';
import SiteBreadcrumb from '../../components/Common/Breadcumb';
import bannerbg from '../../assets/images/backgrounds/updatedteam1.jpeg';
import CtaTwo from '../../components/Common/CtaSection/CtaTwo';
import ServicesMain from './ServicesMain';
import SEOHelmet from '../../components/SEO/SEOHelmet';


// Breadcrumbs Background Image

const Services = () => {

    const [isVisible, setIsVisible] = useState(false);

    const handleScroll = () => {
        const scrollTop = window.scrollY;
        if (scrollTop > 300) {
            setIsVisible(true);
        } else {
            setIsVisible(false);
        }
    };

    useEffect(() => {
        window.addEventListener('scroll', handleScroll);
        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);
    return (
        <React.Fragment>
            <SEOHelmet 
                title="All Products | Scrap Processing Equipment"
                description="Complete range of scrap processing equipment including shredders, shears, magnets, grabbers, and baling machines. Industrial-grade solutions for recycling."
                keywords="scrap equipment, recycling machines, shredder, shear, magnet, grabber, baler"
                canonicalUrl="https://ramanasteels.com/products"
            />
            <Header
                navImg={navImg1}
                parentMenu='allproducts'
                activeMenu="/products"
            />
            {/* SiteBreadcrumb */}
            <SiteBreadcrumb
                pageTitle="All Products"
                pageName="All Products"
                breadcrumbsImg={bannerbg}
            />
            {/* SiteBreadcrumb */}
            <ServicesMain />
            {/*cta-section */}
            {/* <CtaTwo /> */}
            {/*cta-section end */}
            <BackToTop scroll={isVisible} />
            <FooterTwo />
        </React.Fragment>
    );
}

export default Services;